const Grid = require('./Grid'),
    Astar = require('./Astar');
module.exports = {Grid,Astar};